import React from 'react'
import Common from '../components/Common'
import Footer from '../components/Footer'
import ContactPage from '../contact/ContactPage'
export default function Contact() {
  return (
    <div>
      <Common/>
            <ContactPage/>
            <Footer/>
    </div>
  )
}
